import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Landing() {
  const { config } = useAuth();
  const methods = ['email + password'];
  if (config?.enableGoogleIdp) methods.push('Google');
  if (config?.enableAppleIdp) methods.push('Sign in with Apple');
  const methodText = methods.length === 1 ? methods[0] : methods.slice(0, -1).join(', ') + ', or ' + methods.at(-1);

  return (
    <div className="hero">
      <h1>Judging the true cost at the pump.</h1>
      <p>
        GasGavel maps nearby gas stations and breaks every posted price into federal,
        state, and county/district taxes — so you can see exactly where your money goes.
      </p>
      <div className="row" style={{ justifyContent: 'center' }}>
        <Link to="/signup"><button>Create account</button></Link>
        <Link to="/signin"><button className="ghost">I have an account</button></Link>
      </div>
      <p className="small muted" style={{ marginTop: 32 }}>
        Self-signup with admin approval. Sign up with {methodText}.
      </p>
    </div>
  );
}
